import React, { useState, useEffect } from 'react';
import { useParams, Outlet, useLocation } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Link } from 'react-router-dom';

export default function Settings() {
  const { orgId } = useParams();
  const location = useLocation();
  
  const settingsNav = [
    { label: 'General', path: `/enterprise/orgs/${orgId}/settings/general` },
    { label: 'Security', path: `/enterprise/orgs/${orgId}/settings/security` },
    { label: 'Domains', path: `/enterprise/orgs/${orgId}/settings/domains` },
    { label: 'Auth/SSO', path: `/enterprise/orgs/${orgId}/settings/auth` },
    { label: 'Webhooks', path: `/enterprise/orgs/${orgId}/settings/webhooks` },
    { label: 'Infrastructure', path: `/enterprise/orgs/${orgId}/settings/infrastructure` },
  ];

  const isSubPage = !location.pathname.endsWith('/settings');

  if (isSubPage) {
    return <Outlet />;
  }

  return (
    <div className="p-8 space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600 mt-1">Configure your organization</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {settingsNav.map((item) => (
          <Link key={item.path} to={item.path}>
            <div className="p-6 bg-white rounded-lg border border-gray-200 hover:border-primary hover:shadow-md transition-all">
              <h3 className="font-semibold text-gray-900">{item.label}</h3>
              <p className="text-sm text-gray-500 mt-1">Manage {item.label.toLowerCase()} settings</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
